import AssignCommunity from './AssignCommunity';

export default AssignCommunity;